import { FootprintSlice } from 'src/core/models'

const footPrintState: FootprintSlice = {
  footPrintTypes: {
    loading: false,
    footPrintTypes: [],
    error: ''
  },
  myFootprint: {
    loading: false,
    list: [],
    error: ''
  },
  createFootPrint: {
    loading: false,
    footPrint: null,
    success: false,
    error: null
  },
  updateFootPrint: {
    loading: false,
    footPrint: null,
    success: false,
    error: null
  },
  deleteFootPrint: {
    loading: false,
    success: false
  },
  footPrintVsCompensation: {
    loading: false,
    data: {
      footprintCo2Sum: 0,
      co2PurchaseSum: 0,
      data: []
    }
  },
  footPrintHistory: {
    loading: false,
    data: []
  }
}

export { footPrintState as initialState }
